module.exports = __webpack_public_path__ + "static/media/tilda.84d52400.svg";